module.exports = __webpack_public_path__ + "assets/img/collapse_btn.82af52bf.png";